import { render, staticRenderFns } from "./CreatorDetailPremium.vue?vue&type=template&id=35f0813c&scoped=true"
import script from "./CreatorDetailPremium.vue?vue&type=script&lang=js"
export * from "./CreatorDetailPremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0813c",
  null
  
)

export default component.exports